import { useMediaQuery } from "@mui/material";

export default () => useMediaQuery('(max-width:900px)');